import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlterarSenhaService {

  constructor(private api: ApiService) {}

  sendAlterarSenhaData(data) {
    const endpoint = 'Account/change-password';
    const route = environment.API_URL + endpoint;
    return this.api.post$(route, data);
  }
}
